import moment, {Moment} from "moment";
import {DateRange, DateRangePreset} from "../types";

export const getDateRangeFromPreset = (preset: DateRangePreset): DateRange => {
    const now = moment();

    switch (preset) {
        case "currentMonth":
            return {
                start: moment().startOf("month"),
                end: moment().endOf("month"),
                label: "Aktueller Monat",
            };

        case "lastMonth":
            return {
                start: moment().subtract(1, "month").startOf("month"),
                end: moment().subtract(1, "month").endOf("month"),
                label: "Letzter Monat",
            };

        case "currentQuarter":
            return {
                start: moment().startOf("quarter"),
                end: moment().endOf("quarter"),
                label: "Aktuelles Quartal",
            };

        case "lastQuarter":
            return {
                start: moment().subtract(1, "quarter").startOf("quarter"),
                end: moment().subtract(1, "quarter").endOf("quarter"),
                label: "Letztes Quartal",
            };

        case "currentYear":
            return {
                start: moment().startOf("year"),
                end: moment().endOf("year"),
                label: "Aktuelles Jahr",
            };

        case "lastYear":
            return {
                start: moment().subtract(1, "year").startOf("year"),
                end: moment().subtract(1, "year").endOf("year"),
                label: "Letztes Jahr",
            };

        case "custom":
        default:
            return {
                start: moment().startOf("month"),
                end: moment().endOf("month"),
                label: "Benutzerdefiniert",
            };
    }
};

export const DATE_RANGE_PRESET_OPTIONS = [
    {value: "currentMonth", label: "Aktueller Monat"},
    {value: "lastMonth", label: "Letzter Monat"},
    {value: "currentQuarter", label: "Aktuelles Quartal"},
    {value: "lastQuarter", label: "Letztes Quartal"},
    {value: "currentYear", label: "Aktuelles Jahr"},
    {value: "lastYear", label: "Letztes Jahr"},
    {value: "custom", label: "Benutzerdefiniert"},
];

export const formatDateRange = (start: Moment, end: Moment): string => {
    return `${start.format("DD.MM.YYYY")} - ${end.format("DD.MM.YYYY")}`;
};
